import { translateNow } from '../core/services/i18n/translate-now';
import { WHATS_NEW_STRINGS } from './whats-new.strings';

/**
 * Catalog scopes (`public/i18n/<locale>/<scope>.json`) the release data and the stark engine read
 * outside any component. `WhatsNewVisibilityService` loads them for the active language before it
 * builds the releases; components load their own scope with `provideFeatureScope`.
 */
export const ONBOARDING_RELEASE_SCOPES = [
  'onboarding/whats-new',
  'onboarding/tour',
  'onboarding/tour-welcome',
  'onboarding/release-welcome-to-fury',
  'onboarding/release-halloween-2026',
] as const;

/** Translates a catalog key in the active language; the signature of `TranslocoService.translate`. */
export type OnboardingTranslate = (key: string, params?: Record<string, unknown>) => string;

const WHATS_NEW_KEYS: ReadonlySet<string> = new Set(Object.values(WHATS_NEW_STRINGS));

/**
 * `textResolver` of the stark What's New engine. It only resolves the modal chrome keys of
 * {@link WHATS_NEW_STRINGS}; release copy is already translated when the releases are built, so
 * anything else (including literal text from the dev preview) passes through untouched.
 *
 * @param value A What's New label key or an already final text.
 * @returns The label in the active language, or `value` when it is not a label key.
 */
export function resolveWhatsNewLabel(value: string): string {
  return WHATS_NEW_KEYS.has(value) ? translateNow(value) : value;
}
